import { createToast } from "vercel-toast";

/**
 * Copies the provided text to the clipboard.
 * @param {string} text - The text to be copied to the clipboard.
 */
export const copyToClipboard = (text: string) => {
  const textArea = document.createElement("textarea");
  textArea.value = text;
  document.body.appendChild(textArea);
  textArea.select();
  document.execCommand("copy");
  document.body.removeChild(textArea);

  createToast("Copiado com sucesso", {
    type: "success",
    timeout: 2000,
  });
};
